import React, { useState } from "react";
import Box from "@mui/material/Box";
import {Autocomplete, Checkbox, Collapse, FormControlLabel, FormGroup, TextField} from "@mui/material";
import { useSelector } from "react-redux";
import { selectGetCategoriesById } from "../../redux/ProductsSlice";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import Button from "@mui/material/Button";
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import {produce} from "immer";

const UpdateProductGroupNewCategory = ({ allCategories, setActiveForm, setAddCategory }) => {
    const [value, setValue] = useState(null);
    const [category, setCategory] = useState(null);
    const [allowedItems, setAllowedItems] = useState([]);
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down('sm'));
    const handleChange = (event, newValue) => {
        setValue(newValue);
        setCategory(newValue);
        setAllowedItems([])
    };

    const handleCancel = () => {
        setAddCategory(false);
    };

    const handleCategoryItemSelection = (event, checked, itemId) => {
        setAllowedItems(prevState => produce(prevState, draft => {
            const index = draft.findIndex(x => x === itemId);
            if (checked) {
                if (index === -1) {
                    draft.push(itemId);
                }
            } else {
                if (index !== -1) {
                    draft.splice(index, 1);
                }
            }
        }));
    };
    
    const handleSave = () => {
        setActiveForm(prevState => produce(prevState, draft => {
            const categoryIndex = draft.categories.findIndex(x => x.id === category.id);
            if (categoryIndex === -1) {
                draft.categories.push({
                    ...category,
                });
                
                draft.allowedCategories.push({
                    newCategory: true,
                    categoryName: category.name,
                    categoryId: category.id,
                    allowedItems: allowedItems
                })
            }
        }))
        setAddCategory(false);
    }

    const categories = !allCategories ? useSelector(selectGetCategoriesById) : allCategories;

    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                <Typography sx={{ fontWeight: 'bold' }}>Choose Category</Typography>
            </Box>
            <Box sx={{ my: 2}}>
                <Autocomplete
                    id="categories"
                    options={categories}
                    onChange={handleChange}
                    value={value}
                    getOptionLabel={(option) => {
                        if (typeof option === 'string') {
                            return option;
                        }
                        if (option.inputValue) {
                            return option.inputValue;
                        }
                        if (option.name) {
                            return option.name;
                        }
                        return '';
                    }}
                    handleHomeEndKeys
                    renderOption={(props, option) => {
                        const { key, ...optionProps } = props;
                        return (
                            <li key={key} {...optionProps}>
                                {option.name}
                            </li>
                        );
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Categories"
                            placeholder={"Select"}
                            sx={{
                                width: {
                                    xs: '190px !important',
                                    sm: '250px !important',
                                },
                            }}
                        />
                    )}
                />
                <Collapse in={value?.productItems.length > 0} >
                    <Typography variant="subtitle2" sx={{ mt: 2}}>Select Items</Typography>
                    <FormGroup>
                        {value?.productItems.map((item, index) => (
                            <FormControlLabel control={
                                <Checkbox
                                    checked={allowedItems.some(x => x === item.id)}
                                    onChange={(event, checked) => handleCategoryItemSelection(event, checked,  item.id)}
                                />
                            } label={item.name} key={index} />
                        ))}
                    </FormGroup>
                </Collapse>
                <Box sx={{mt: 2}}>
                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: theme.palette.tertiary.secondary
                        }}
                        onClick={handleSave}
                        disabled={allowedItems.length === 0}
                    >
                        Add
                    </Button>
                    <Button variant="outlined" color="error" onClick={handleCancel} sx={{ ml: 2 }}>
                        Cancel
                    </Button>
                </Box>
            </Box>
        </>
    );
};

export default UpdateProductGroupNewCategory;